import React, { useState } from 'react'
import { Label as UILabel } from '@faststore/ui'
import Checkbox from 'src/components/ui/Checkbox'
import { normalize } from 'src/utils/similars'
import type { ValuesObjectProps } from 'src/components/search/Filter/types'
import type { IStoreSelectedFacet } from '@faststore/api'

import listWithImages from '../../data/listWithImages.json'
import type { IListWithImages } from '../../FilterQuantity'
import storeConfig from '../../../../../../../../store.config'

import './filter-item-with-image.scss'

interface IFilterItemWithImage {
  id: string
  itemValues: ValuesObjectProps
  testId: string
  selectedFacets: IStoreSelectedFacet[]
  keyValue: string
  testFacets: (facetValue: string, itemValue: string) => boolean
  onFacetChange: (item: IStoreSelectedFacet) => void
}

export default function FilterItemWithImage({
  id,
  itemValues,
  testId,
  selectedFacets,
  keyValue,
  testFacets,
  onFacetChange,
}: IFilterItemWithImage) {
  const baseClass = 'filter__item-withImage'
  const [imageFallback, setImageFallback] = useState<string>()
  const listKeysWithImages = listWithImages as IListWithImages
  const { account } = storeConfig

  const getImageUrl = (itemLabel: string, fallback = false) => {
    const itemLabelNormalized = normalize(itemLabel)
    const isRenderBigImages = listKeysWithImages?.[keyValue]

    let imageReturnUrl = `https://${account}.vtexassets.com/arquivos/${isRenderBigImages}__fallback.png`

    if (isRenderBigImages && !fallback) {
      imageReturnUrl = `https://${account}.vtexassets.com/arquivos/${isRenderBigImages}__${itemLabelNormalized}.png`
    }

    return imageReturnUrl
  }

  const imgURL = getImageUrl(itemValues?.label)

  const showFallbackImageOrHide = (
    e: React.SyntheticEvent<HTMLImageElement>
  ) => {
    if (imageFallback) {
      const target = e?.target as HTMLImageElement

      target.style.display = 'none'

      return false
    }

    setImageFallback(getImageUrl(itemValues?.label, true))

    return true
  }

  return (
    <>
      {(imageFallback || imgURL) && (
        <div className={`${baseClass}-container-imageBig`}>
          <img
            alt={itemValues?.label}
            src={imageFallback ?? imgURL}
            className={`${baseClass}-imageBig`}
            onError={(e) => showFallbackImageOrHide(e)}
          />
        </div>
      )}
      <div className={`${baseClass}-info`}>
        <Checkbox
          id={id}
          checked={selectedFacets
            ?.filter(
              (facet) => facet?.key !== 'price' && facet?.key === keyValue
            )
            ?.some((facet2) => testFacets(facet2.value, itemValues?.value))}
          onChange={() =>
            onFacetChange({ key: keyValue, value: itemValues?.value })
          }
          data-testid={`${testId}-accordion-panel-checkbox`}
          data-value={itemValues?.value}
          data-quantity={itemValues?.quantity}
        />
        <UILabel htmlFor={id} className="title-small">
          {itemValues?.label}
        </UILabel>
        <span className={`${baseClass}-info__quantity`}>
          ({itemValues?.quantity})
        </span>
      </div>
    </>
  )
}
